import { render, staticRenderFns } from "./FolderItem.vue?vue&type=template&id=00bad082&scoped=true&"
import script from "./FolderItem.vue?vue&type=script&lang=js&"
export * from "./FolderItem.vue?vue&type=script&lang=js&"
import style0 from "./FolderItem.vue?vue&type=style&index=0&id=00bad082&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00bad082",
  null
  
)

export default component.exports